import { GenderEnum } from '../../enums/GenderEnum';
import { AddressDto } from '../AddressDto';

export class PersonDto {
  initials: string;
  middleName: string;
  surname: string;
  dateOfBirth: Date;
  gender: GenderEnum;
  socialSecurityNumber: string;
  nationality: string;
  isSmoker: boolean;
  occupation: string;
  phoneNumber: string;
  email: string;
  emailAddress: string;
  identityVerified: boolean;
  address: AddressDto;
}
